import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { SVGICONS } from "config";
import { useSelector } from "react-redux";
import { calculateItemsNetAmount } from "utils/Utils";
import { CustomButton } from "components/Button";
import { PriceRender } from "components/DisplayPrice";

function ViewBasket({ viewBasketPage }) {
  const { cart } = useSelector((state) => state?.cart);
  const { discountInfo } = useSelector((state) => state?.Discounts);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const itemNetPrice = calculateItemsNetAmount(cart);
    setTotal(itemNetPrice.itemsNetAmount);
  }, [cart, discountInfo]);

  if (!cart?.length) return null;

  return (
    <div className="closed-basket-overview-wrapper w-full">
      <CustomButton
        type="button"
        onClick={viewBasketPage}
        className="w-full py-3 px-6 rounded-24x border bg-brand-base-primary border-brand-text-primary text-brand-text-primary text-16x font-semibold flex items-center justify-between relative"
      >
         <div className="relative flex items-center pr-2">
            <SVGICONS.BasketBag stroke="#fff" />
            <span className="absolute top-0 h-4 w-4 flex items-center justify-center rounded-full bg-brand-bgtext text-brand-base-primary text-12x" style={{right: "0px"}}>
              {cart?.length ?? 0}
            </span>
          </div>
          <span className="mx-2">{t("View Basket")}</span>
          <PriceRender price={total} className="text-16x leading-none text-white"  currencySymbolClassName="text-white"/>
      </CustomButton>
    </div>
  );
}

export default ViewBasket;
